export default __webpack_public_path__ + "static/media/Expo.9f9587a1.png";